<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="error-404">
	    <dl class="main">
			<dt></dt>
			<dd>
	           <h2>很抱歉！页面无法访问......</h2>
	           温馨提示：
	           <p>1、请检查您访问的网址是否正确</p>
	           <p>2、您没有授权访问的文件或目录</p>
	           <p>3、访问的页面可能已删除或页面已失效</p>
	           <div style="margin-top: 30px;">
				   <el-button type="primary" class="go" @click="goClick">返回上一页</el-button>
				   <el-text style="margin-left: 16px;" type="warning">3秒后自动跳转</el-text>
			   </div>
			</dd>
	    </dl>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,inject,onMounted,onUnmounted } from 'vue';
	import { payHeader,payFooter } from 'landui-ui';
	import { useRouter } from 'vue-router';
	
	const router = useRouter();
	const bgStatus = ref(true);
	const domain = inject('domain');
	const remainingTime = ref(3);
	const intervalId = ref(null);
	
	const goClick = () => {
		intervalId.value = setInterval(() => {
		   remainingTime.value--;
		   if (remainingTime.value < 0) {
			   clearInterval(intervalId.value);
			   remainingTime.value = 3;
			   router.back();
		   }
		}, 1000)
	}
	
	onMounted(() => {
		goClick()
	});
	onUnmounted(() => {
		clearInterval(intervalId.value);
	});
	
</script>

<style lang="scss" scoped>
	.error-404{
		padding: 200px 0 100px;
		overflow: hidden;
		.main{
			width: 1280px;
			margin: 0 auto;
			text-align: center;
			dt{ display: inline-block; vertical-align: text-top; width: 335px; min-height: 300px; margin-right: 70px; background: url(https://www.landui.com/404.png) left center no-repeat;}
			dd{
				padding-top: 10px;
				display: inline-block;
				vertical-align: text-top;
				text-align: left;
				color: #666666;
				line-height: 30px;
				h2 {
				    color: #333333;
				    font-size: 30px;
				    font-weight: bolder;
					margin-bottom: 30px;
				}
			}
		}
	}
</style>